import { keys, forEach, isEmpty, clone, filter, join, toLower } from 'lodash';


export const mutations = {

  FORMAT_NODE_UPDATE(state, node) {
    if (!node) {
      return
    }
    let oldValue = null
    const fields = node.field.split('.')
    if (fields.length > 1) {
      const field1 = `${fields[0]}`
      const field2 = `${fields[1]}`
      oldValue = node.node[field1][field2]
      if (node.oldValue && oldValue !== node.oldValue) {
         state.nodeMapForUpload = null
         return
      }
      node.node[field1][field2] = node.value
    } else {
      const fieldName = `${node.field}`
      oldValue = node.node[fieldName]
      if (node.oldValue && oldValue !== node.oldValue) {
         state.nodeMapForUpload = null
         return
      }
      node.node[fieldName] = node.value
    }
    state.nodeMapForUpload = {
      obj: node.node,
      root_id: state.parentId
    }
  },
  UPDATE_PATIENT_DATA(state, patientData) {
    state.patientDataMap = patientData
  },
  LOAD_PATIENT_DATA(state, patientData) {
    state.patientData = patientData
    state.parentId = patientData._id
  },
  LOAD_VIEW_DATA(state, apiData) {
    state.apiData = apiData
  },
  LOAD_INDEX(state, index) {
    state.index = index
  },
}
